/**
 * ComingSoonPanel — friendly placeholder for PLANNED backend routes.
 *
 * Used by surfaces that depend on /v3/audit-reports/* or other routes not yet
 * shipped. Rendering this is preferred over throwing or showing a broken page.
 *
 * Thin wrapper over the shared Banner primitive.
 */

import type { ReactNode } from 'react';
import { Banner } from '@/components/primitives';

export interface ComingSoonPanelProps {
  headline: string;
  body: string;
  route?: string;
  extra?: ReactNode;
}

export function ComingSoonPanel({ headline, body, route, extra }: ComingSoonPanelProps): JSX.Element {
  return (
    <Banner tone="info" title={headline} icon={<span aria-hidden style={{ fontSize: 18 }}>🚧</span>}>
      <p style={{ margin: 0 }}>{body}</p>
      {route && (
        <div style={{ marginTop: 'var(--sp-5)', fontFamily: 'var(--font-mono)', fontSize: 11, opacity: 0.75 }}>
          Planned route: <code>{route}</code>
        </div>
      )}
      {extra && <div style={{ marginTop: 'var(--sp-5)' }}>{extra}</div>}
    </Banner>
  );
}
